module.exports = __webpack_public_path__ + "img/rubick.e6561c67.jpg";